import { Box } from '@mui/material';
import React from 'react';
import avatar1 from '../assets/ksim/avatar-1.svg';
import avatar3 from '../assets/ksim/avatar-3.svg';

const ContactAvatar = () => (
  <>
    <Box
      component="img"
      src={avatar1}
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: '-84px',
        margin: 'auto',
        width: '75px',
        height: '100px;',
      }}
    />
    <Box
      component="img"
      src={avatar3}
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '77px',
        right: 0,
        margin: 'auto',
        width: '75px',
        height: '100px;',
      }}
    />
  </>
);

export default ContactAvatar;
